export enum DisplayMode {
    DEFAULT = 'default',
    MOBILE = 'mobile',
    TABLET = 'tablet',
}
